import { Component, ComponentClass, createElement, FunctionComponent, HtmlHTMLAttributes } from "react";
import classnames from "classnames";
import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";
import omit from "lodash/omit";
import { Cell } from "react-table";
import { BodyCell } from "./BodyCell";
import { RowComponent } from "./RowComponent";

import styles from "../style.module.scss";

export type BodyRowProps<T extends object> = {
  style: any,
  cells: Cell<T, any>[],
  className?: string,
  to?: string,
  rowComponent?: string | FunctionComponent<any> | ComponentClass<any>,
} & HtmlHTMLAttributes<HTMLDivElement>;

export class BodyRow<T extends object> extends Component<BodyRowProps<T>, any> {
  prevInfo: any = null;

  extractValuableProps(props: BodyRowProps<T>) {
    const excl = [ "allCells", "cells", "getRowProps", "getToggleRowSelectedProps", "toggleRowSelected" ];

    const { cells: nextCells, ...restNextProps } = props;

    return {
      cells: nextCells.map(x => ({
        value: x.value,
        row: omit(x.row, excl),
      })),
      ...restNextProps,
    };
  }

  shouldComponentUpdate(nextProps: Readonly<BodyRowProps<T>>, nextState: Readonly<any>, nextContext: any): boolean {
    return !isEqual(this.prevInfo, this.extractValuableProps(nextProps));
  }

  componentDidMount() {
    this.prevInfo = cloneDeep(this.extractValuableProps(this.props));
  }

  componentDidUpdate(prevProps: Readonly<BodyRowProps<T>>, prevState: Readonly<any>, snapshot?: any) {
    this.prevInfo = cloneDeep(this.extractValuableProps(this.props));
  }

  render() {
    const { style, cells, className, rowComponent, ...restProps } = this.props;


    return createElement(
      rowComponent as string | FunctionComponent<any> | ComponentClass<any>,
      {
        style,
        className: classnames(className, styles.bodyRow),
        role: "row",
        ...restProps,
      } as any,
      cells.map(cell => <BodyCell key={cell?.column?.id} cell={cell} />),
    );

  }

  static defaultProps = {
    rowComponent: RowComponent,
  };
}


export default BodyRow;
